import { SettingsFeatureListController } from './settings_feature_list_controller';

export class SettingsFeatureListComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-settings/src/components/settings_feature_list/settings_feature_list.html';
  public controller: any = SettingsFeatureListController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/components/settings_feature_list/settings_feature_list_component.ts